export default "__VITE_ASSET__BYkqDGnY__"